import instance from '../../api';
import { message } from 'antd';
import { ErrorNotification } from '../../../Utils/data';
import { QueryClient } from 'react-query';
import { TableParams } from '../../../Utils/TableTypes';

const queryClient = new QueryClient();
export const adminUser = {
  async read(
    adminName: string | undefined,
    adminEmail: string | undefined,
    status: boolean | undefined | null,
    tableParams?: TableParams,
  ) {
    const safePage = tableParams?.pagination?.current ?? 1;
    const safeSearchName = adminName ?? '';
    const safeSearchEmail = adminEmail ?? '';

    const params = new URLSearchParams({
      page: String(safePage),
      perPage: '10',
      searchName: safeSearchName,
      searchEmail: safeSearchEmail,
    });

    // boolean bo‘lsa qo‘shiladi
    if (typeof status === 'boolean') {
      params.append('status', String(status)); // "true" / "false"
    }

    const url = `admins/get-all?${params.toString()}`;

    try {
      const { data } = await instance(url);
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },
  async adminFindOne(Id: string | number | undefined) {
    try {
      const { data }: { data: any } = await instance(`admins/get-admin/${Id}`);
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async adminPatch(id: string | undefined, body: any) {
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`admins/update-admin/${id}`, {
        method: 'PATCH',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },
  async updateUser() {
    const { data }: { data: any } = await instance(`users/me`);
    localStorage.setItem('user', JSON.stringify(data));
    queryClient.setQueryData('user', data);
    return data;
  },

  async adminDelete(id: string | undefined, body: boolean | object) {
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`admins/delete-admin/${id}`, {
        method: 'DELETE',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async addAdmin(body: number | string) {
    message.loading({ content: 'Loading...', key: body });
    try {
      const { data } = await instance('admins/create-admin', {
        method: 'POST',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key: body, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },
  async bulkCreateAdmins(body: any[]) {
    const key = 'bulkCreateAdmins';
    message.loading({ content: 'Loading...', key });
    try {
      const { data } = await instance('admins/bulk-create', {
        method: 'POST',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async changePassword(password: number, id: number | string | undefined) {
    const { data }: { data: any } = await instance(`admins/update-password/${id}`, {
      method: 'POST',
      data: password,
    });
    return data;
  },

  async userInfo() {
    const { data } = await instance('admins/user-info');
    return data;
  },
  async unreadCount() {
    const { data } = await instance('admins/unread-count');
    return data;
  },
};
